<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useFormRules } from '~~/composables/useFormRules'
import { useAppStore } from '~/stores/app'
import { useAuthStore } from '~/stores/auth'

const appStore = useAppStore()
const { isMobile } = storeToRefs(appStore)

const state = reactive({
  dialog: false,
  email: '',
  mode: '',
  resolve: (val: boolean) => {
    console.log(`Resolved with value: ${val}`)
  },
  reject: (val: boolean) => {
    console.log(`Rejected with value: ${val}`)
  },
})

const isPending = ref(false)

const { ruleEmail, ruleMin, ruleRequired } = useFormRules()

const authStore = useAuthStore()
const { sendResetEmail } = authStore

const open = async (email: string, mode?: string) => {
  state.dialog = true
  state.email = email
  state.mode = mode ? mode : ''

  console.log(`LoginResetDialog.open()`)

  return new Promise<boolean>((resolve, reject) => {
    state.resolve = resolve
    state.reject = reject
  })
}

defineExpose({
  open,
})

const confirm = () => {
  state.resolve(true)
  state.dialog = false
  navigateTo({ path: `/reset` })
}

const cancel = () => {
  state.resolve(true)
  state.dialog = false
}

async function passwordEmail() {
  sendResetEmail(state.email, state.mode === 'Director' ? true : false)
  state.dialog = false
}
</script>

<template>
  <!-- CATEGORY DIALOG -->
  <v-dialog v-model="state.dialog" :fullscreen="isMobile" :transition="isMobile ? 'dialog-bottom-transition' : 'scale-transition'" scrollable max-width="600px">
    <v-card>
      <!-- DIALOG TITLE -->
      <v-toolbar color="primary" :density="isMobile ? 'compact' : 'default'">
        <v-toolbar-title>{{ state.mode === 'Director' ? 'Reset User Password?' : 'Reset Password?' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="pb-3">
        <div v-if="state.mode === 'Director'">A link to reset the user's password will automatically be sent to the email address associated with their account. If the link has expired, try sending another email by clicking on the button again, or contact your chapter's administrator for assistance.</div>
        <div v-else>A link to reset your password will automatically be sent to the email address associated to your account. If the link has expired, try sending another email by clicking on the button again, or contact your chapter's administrator for assistance.</div>

        <v-row class="my-3">
          <v-col cols="12" class="pt-3 text-center">
            <v-col cols="12" class="py-0">
              <v-text-field v-model="state.email" :rules="[ruleRequired]" variant="outlined" density="compact" label="Email"></v-text-field>
            </v-col>
            <v-btn :loading="isPending" color="success" size="default" :density="isMobile ? 'compact' : 'default'" variant="elevated" :class="isPending ? 'px-9' : 'px-9'" @click="passwordEmail"
              >Send Password Reset Link

              <template #loader> <v-progress-circular indeterminate color="white" class="mr-3"></v-progress-circular>Send Password Reset Link </template>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
